import { render, staticRenderFns } from "./WorkGlobalIconButton.vue?vue&type=template&id=94942556"
import script from "./WorkGlobalIconButton.vue?vue&type=script&lang=js"
export * from "./WorkGlobalIconButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports